class ListStore {
  constructor(axios) {
    this.axios = axios
    this.aggregations = {}
    this.state = {}
    this.meta = {}
  }

  getFolder(folderId) {
    return this.axios.get(`list/folders/${folderId}`).then(({data}) => {
      return data
    })
  }

  getFolders(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/folders', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { folders: data.data, meta: data.meta })

      return data
    })
  }

  getSharedFolders(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/shared_folders', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedFolders: data.data, meta: data.meta })

      return data
    })
  }

  getMySharedFolders(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/my_shared_folders', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { mySharedFolders: data.data, meta: data.meta })

      return data
    })
  }

  getRecordsForNavigation(folderId) {
    return this.axios.get('list/records', { params: { folder_id: folderId } }).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordsForNavigation: data })
    })
  }

  getRecordsForNavigationVersioned(recordId) {
    return this.axios.get('list/record_versions', { params: { id: recordId } }).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordsForNavigationVersioned: data})
    })
  }

  getProducts(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/products', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { products: data.data, meta: data.meta })

      return data
    })
  }

  getDocumentTypes(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/document_types', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { document_types: data.data, meta: data.meta })

      return data
    })
  }

  getSharedProducts(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/shared_products', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedProducts: data.data, meta: data.meta })

      return data
    })
  }

  getSharedDocumentTypes(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/shared_document_types', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedDoumentTypes: data.data, meta: data.meta })

      return data
    })
  }

  getContacts(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/contacts', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { contacts: data.data, meta: data.meta })

      return data
    })
  }

  getSharedWithContacts(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/shared_with_contacts', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedWithContacts: data.data, meta: data.meta })

      return data
    })
  }

  getConnectedContacts(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/connected_contacts', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { connectedContacts: data.data, meta: data.meta })

      return data
    })
  }

  getUsers(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/users', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { users: data.data, meta: data.meta })

      return data
    })
  }

  getTags(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/tags', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { tags: data.data, meta: data.meta })

      return data
    })
  }

  headerSearchViaEs(params) {
   return this.axios.get('searches', { params: params }).then(({data}) => {
     this.state = Object.assign({}, this.state, { searchResultsHeader: data.result })
     this.meta = Object.assign({}, this.meta, { searchResultsHeader: data.meta })
   })
  }

  searchViaEs(params) {
    return this.axios.get('list/searches/search_via_es', {params: params}).then(({data}) => {
      this.state = Object.assign({}, this.state, { searchResults: data.result })
      this.meta = Object.assign({}, this.meta, { searchResults: data.meta })
      this.aggregations = Object.assign({}, this.aggregations, { countBySourceType: data.count_by_source })
    })
  }

  getChecklistItems(params) {
    return this.axios.get('list/checklist_items', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { checklists: data })
    })
  }

  getRecordsForVersion(folder, record, version) {
    return this.axios.get('list/records', {params: {folder_id: folder.id, record_id: record.id, version: version}}).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordsForNewVersion: data })
    })
  }

  getSharedTags(organizationId) {
    return this.axios.get('shared_tags', {params:{organization_id: organizationId}}).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedTags: data })
    })
  }

  getMyShareInvites(params) {
    return this.axios.get('my_share_invites', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { myShareInvites: data })
    })
  }

  getMentions() {
    return this.axios.get('list/mentions').then(({data}) => {
      this.state = Object.assign({}, this.state, { mentions: data })
    })
  }

  getAddressBook(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('list/address_book', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { addressBook: data.data, meta: data.meta })

      return data
    })
  }
}

export default ListStore
